import { faunaAPI } from "../fauna-api";

export const getSuppliers = async () => faunaAPI.callFunction('get_all_Suppliers')
export const getSupplier = async () => faunaAPI.callFunction('get_Supplier', id)
export const createSupplier = async payload => faunaAPI.callFunction('create_Supplier', payload)
export const getAllSpendingBySupplier = async payload => faunaAPI.callFunction('get_all_spending_by_Supplier', payload)